import { yupResolver } from '@hookform/resolvers/yup';

import {
  object,
  REQUIRED_MESSAGE,
  string,
  match,
} from './general';

const schema = object().shape({
  currentPassword: string().required(REQUIRED_MESSAGE),
  password: string().required(REQUIRED_MESSAGE),
  passwordConfirmation: match(
    'password',
    'As senhas devem ser iguais',
  ).required(REQUIRED_MESSAGE),
});

export default yupResolver(schema);
